export enum RawSetOperatorType {
    DR_THIS_PROPERTY = 'this-property'
}